module.exports = __webpack_public_path__ + "files/803d1a498b55a75bc8c4a33438a4ee7e.svg";